import { get } from '../helpers/axios';

export function search(registeredAppId, searchString) {
  return get(`/registered_apps/${registeredAppId}/accounts`, { params: { search: searchString } });
}
